<script setup>
import { computed } from 'vue'
import { Icon } from '@components'

const props = defineProps({
    title: {
        type: String,
        defaut: ''
    },
    icon: {
        type: String,
    },
    active: {
        type: Boolean,
        default: false
    },
    size: {
        type: String
    },
    textClass: {
        type: String,
    },
    iconSize: {
        type: String,
        default: '22px'
    },
    iconStyle: {
        type: String,
    }
})

const buttonSize = computed(() => {
    switch (props.size) {
        case 'xs':
            return 'py-2 px-[10px]'
        case 'sm':
            return 'py-[10px] px-4'
        case 'md':
            return 'py-3 px-4'
        default:
            return ''
    }
})
</script>

<template>
    <div class="cursor-pointer flex items-center gap-2  rounded-[6px] shadow outline" :class="[props.active ? 'outline-2 outline-[#7F56D9] text-[#7F56D9]' : 'outline-1 outline-[#D0D5DD] text-[#667085]'], buttonSize">
        <Icon :name="props.icon" v-if="props.icon" :size="props.iconSize" :style="props.iconStyle"></Icon>
        <div class="font-semibold text-sm" :class="{ 'text-[#101828]': props.active }, props.textClass">{{ props.title }}</div>
    </div>
</template>


<style>

</style>